import { CompanyEntity } from "../entity/CompanyEntity";
import { Company } from "../gateway/Company/Company";

export class GetCompaniesByIdsAndFilterUsecase {
    constructor() {
        this.CompanyGateway = new Company();
    }

    async execute({ companyIds = [], filter = {}, entity = false } = {}) {
        if (!Array.isArray(companyIds) || !companyIds.length) return [];
        let companies = await this.CompanyGateway.getByIds(companyIds);
        if (!Array.isArray(companies) || !companies.length) return [];
        const statusFilter = Array.isArray(filter?.status) ? filter.status : [];
        if (statusFilter.length) {
            companies = this.filterStatus(companies, statusFilter);
        }
        if (entity)
            return companies.map((company) => CompanyEntity.restore(company));
        return companies;
    }

    filterStatus(companies, status) {
        return companies.filter((company) => status.includes(company.status));
    }
}
